function montaChaveCache(usuarioEmail, codigoSiconfi, exercicio) {
  const exercicioKey = exercicio === null || exercicio === undefined || exercicio === "" ? "_" : exercicio;
  return `export-emails:${usuarioEmail}:${codigoSiconfi}:${exercicioKey}`;
}

export function buscarEmailsCache(usuarioEmail, codigoSiconfi, exercicio) {
  try {
    const raw = localStorage.getItem(montaChaveCache(usuarioEmail, codigoSiconfi, exercicio));
    if (!raw) return null;

    const emails = JSON.parse(raw);
    if (!Array.isArray(emails)) return null;

    return emails;
  } catch (error) {
    return null;
  }
}

export function salvarEmailsCache(usuarioEmail, codigoSiconfi, exercicio, emails) {
  try {
    localStorage.setItem(montaChaveCache(usuarioEmail, codigoSiconfi, exercicio), JSON.stringify(emails));
  } catch (error) {
    // Falha ao salvar (quota excedida, localStorage indisponível) não pode quebrar o fluxo de exportação.
  }
}
